export default {
  textField: {
    '& .MuiInputLabel-root': {
      color: 'text.dark',
      fontWeight: '300',
      '&.Mui-focused': {
        color: 'text.dark',
      },
    },
    '& .MuiPickersInputBase-root': {
      backgroundColor: 'transparent',
      '& .MuiPickersInputBase-input': {
        fontSize: '14px',
        fontWeight: '300',
        lineHeight: '1.15',
        pl: 2,
        py: 1.25,
      },
      '& .MuiPickersSectionList-sectionContent': {
        color: 'text.dark',
        fontSize: '14px',
        fontWeight: '300',
      },
    },
    '& .MuiSvgIcon-root': {
      height: 'auto',
      width: '17px',
    },
    '& .MuiPickersOutlinedInput-notchedOutline': {
      borderColor: 'background.grey.blue_3',
    },
    '& .MuiPickersInputBase-root:hover .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: 'background.grey.blue_3',
      },
    '& .MuiPickersInputBase-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: 'background.grey.blue_3',
        borderWidth: '1px',
      },
    '& .MuiPickersInputBase-root.Mui-focused:not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline':
      {
        borderColor: 'background.grey.blue_3',
        borderWidth: '1px',
      },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
};
